// ShiftStatusBadge.jsx
export default function Badge({ variant, children }) {
  const color =
    variant === 'in'
      ? 'bg-emerald-100 text-emerald-700 border-emerald-200'
      : 'bg-amber-100 text-amber-700 border-amber-200';
  return (
    <span className={`px-3 py-1 rounded-full text-xs font-semibold border ${color}`}>{children}</span>
  );
}
